module.exports = __webpack_public_path__ + "static/media/28.b172bc8b.png";